import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { usePublicConfig } from "@/lib/useConfig";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, ErrorNote } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const { trialDays } = usePublicConfig();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(form.name, form.email, form.password);
      navigate("/onboarding", { replace: true });
    } catch (err) {
      setError(errMsg(err, "Unable to create account"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle={`${trialDays} days of full access, free. No card required.`}
      footer={
        <>
          Already registered?{" "}
          <Link to="/login" className="text-primary hover:underline" data-testid="link-login">Sign in</Link>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
        <ErrorNote message={error} />
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input id="name" data-testid="register-name" required value={form.name} onChange={set("name")} className="rounded-none" placeholder="Alex Kumar" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Work email</Label>
          <Input id="email" data-testid="register-email" type="email" required value={form.email} onChange={set("email")} className="rounded-none" placeholder="you@company.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="register-password" type="password" required minLength={8} value={form.password} onChange={set("password")} className="rounded-none" placeholder="min 8 characters" />
        </div>
        <Button type="submit" data-testid="register-submit" disabled={busy} className="w-full rounded-none gap-2">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </Button>
      </form>
    </AuthShell>
  );
}
